import React from "react";

const Typo = React.forwardRef(({
  inline,
  level,
  className,
  sHigh,
  noWrap,
  type,
  size,
  style,
  children,
  ...rest
}, ref) => {
  let tagName = "div";
  if (inline) {
    tagName = "span";
  } else if (level) {
    tagName = "h" + level;
  }

  const classes = [
    className,
    sHigh && "ta-typeface--high",
    noWrap && "ta-typeface--singleline",
    (type ? "ta-typeface_" + type : "ta-typeface_body") +
      "-" +
      (size ? size : "l"),
  ]
    .filter(Boolean)
    .join(" ");

  return React.createElement(tagName, { ref, className: classes, style, ...rest }, children);
});

export default Typo;
